module.exports = __webpack_public_path__ + "img/white-w-disc-w-case-opened.f5c4e9da.svg";